<!-- Modal Header -->
@if (modal_name) {
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer"
      (click)="minimise = !minimise"
    ></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer"></i>
  </div>
</div>
}

<!-- Modal Body -->
<div class="modal-body" [ngClass]="{ 'no-body-scroll': modal_name }" [hidden]="minimise">
  @if (showFormLoader) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}
  @if (!showFormLoader) {
<div class="form-horizontal">
    <table class="table table-bordered form-inline">
      <tbody>
        <!-- Line 7a -->
        <tr style="padding-bottom: 0 !important">
          @if (!tax_year_flag) {
<td style="padding-left: 5px !important">7a</td>
}
          @if (tax_year_flag) {
<td style="padding-left: 5px !important"></td>
}
          <td style="padding-left: 5px !important">
            Was any income of the foreign corporation blocked?
          </td>
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            <div class="radioBtnPosition col-md-4">
              Yes
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'Y'"
                name="radioBlk"
                [(ngModel)]="radioBlk"
                class="radio"
              />
            </div>
            <div class="radioBtnPosition col-md-4">
              No
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'N'"
                name="radioBlk"
                [(ngModel)]="radioBlk"
                class="radio"
              />
            </div>
          </td>
        </tr>
        <!-- Line 7b -->
        <tr style="padding-bottom: 0 !important">
          @if (!tax_year_flag) {
<td style="padding-left: 5px !important">7b</td>
}
          @if (tax_year_flag) {
<td style="padding-left: 5px !important"></td>
}
          <td style="padding-left: 5px !important">
            Was any income of the foreign corporation unblocked?
            <span
              ><br />If the answer to either question is Yes, attach an explanation.</span
            >
          </td>
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            <div class="radioBtnPosition col-md-4">
              Yes
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'Y'"
                name="radioUnblk"
                [(ngModel)]="radioUnblk"
                class="radio"
              />
            </div>
            <div class="radioBtnPosition col-md-4">
              No
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'N'"
                name="radioUnblk"
                [(ngModel)]="radioUnblk"
                class="radio"
              />
            </div>
          </td>
        </tr>
        <!-- Line 8a (hidden when tax_year_flag) -->
        @if (!tax_year_flag) {
<tr style="padding-bottom: 0 !important">
          <td style="padding-left: 5px !important">8a</td>
          <td style="padding-left: 5px !important">
            Did this U.S. shareholder have an extraordinary disposition (ED) account with
            respect to the foreign corporation at any time during the tax year (see
            instructions)?
          </td>
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            <div class="radioBtnPosition col-md-4">
              Yes
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'Y'"
                name="radiodisp"
                [(ngModel)]="radiodisp"
                (ngModelChange)="checkingForValidationForI($event)"
                class="radio"
              />
            </div>
            <div class="radioBtnPosition col-md-4">
              No
              <input
                type="radio"
                style="margin-left: 5px"
                [value]="'N'"
                name="radiodisp"
                [(ngModel)]="radiodisp"
                (ngModelChange)="checkingForValidationForI($event)"
                class="radio"
              />
            </div>
          </td>
        </tr>
}
        <!-- Line 8b -->
        @if (!tax_year_flag) {
<tr style="padding-bottom: 0 !important">
          <td style="padding-left: 5px !important">8b</td>
          <td style="padding-left: 5px !important" colspan="2">
            <div>
              If the answer to question 8a is Yes, enter the U.S. shareholders ED account
              balance at the beginning of the CFC year and at the end of the tax year $
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="radiodisp === 'N'"
                [(ngModel)]="boyEd"
              />
              and at the end of the tax year $
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [disabled]="radiodisp === 'N'"
                [(ngModel)]="eoyEd"
              />
              Provide an attachment detailing any changes from the beginning to the ending
              balances.
            </div>
          </td>
        </tr>
}
        <!-- Line 8c -->
        @if (!tax_year_flag) {
<tr style="padding-bottom: 0 !important">
          <td style="padding-left: 5px !important">8c</td>
          <td style="padding-left: 5px !important" colspan="2">
            <div>
              Enter the CFC aggregate ED account balance with respect to all U.S.
              shareholders at the beginning of the CFC year $
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [(ngModel)]="boyAgg"
              />
              and at the end of the tax year $
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [(ngModel)]="eoyAgg"
              />
              Provide an attachment detailing any changes from the beginning to the ending
              balances.
            </div>
          </td>
        </tr>
}
        <!-- Line 9 -->
        @if (!tax_year_flag) {
<tr style="padding-bottom: 0 !important">
          <td style="padding-left: 5px !important">9</td>
          <td style="padding-left: 5px !important">
            <div>
              Enter the sum of the hybrid deduction accounts with respect to stock of the
              foreign corporation (see instructions)
            </div>
          </td>
          <td class="col-md-1" style="padding-left: 5px !important; align-items: center">
            <div class="input-group">
              <span class="input-group-addon">$</span>
              <input
                style="text-align: right; padding-left: 5px"
                type="text"
                class="form-control"
                [(ngModel)]="totDed"
              />
            </div>
          </td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>

<!-- Modal Footer -->
@if (modal_name) {
<div class="modal-footer" [hidden]="minimise">
  <button
    class="btn btn-info btn-sm save-button"
    type="button"
    (click)="saveScheduleIForm()"
    [disabled]="crudLoading"
  >
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">
    Cancel
  </button>
</div>
}
